import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'mentorship'

const initialState = {
  list: null,
  count: null,
  current: null,
  mentors: null,
}

export const search = createApiAction('mentorship/search', client.search('/api/mentorship'))
export const retrieve = createApiAction('mentorship/retrieve', client.retrieve('/api/mentorship/:id'))
export const save = createApiAction('mentorship/save', client.save('/api/mentorship'))
export const destroy = createApiAction('mentorship/destroy', client.destroy('/api/mentorship/:id'))
export const mentorList = createApiAction('mentorship/mentor-list', client.search('/api/lookup/permission'))

const updateList = (state, action) => {
  const item = action.payload
  const found = state.list?.find(m => m.id === item.id)
  state.list = found
    ? state.list.map(m => (m.id === item.id ? item : m))
    : [...(state.list || []), item]
  state.current = item
}

const mentorshipSlice = createSlice({
  name,
  initialState,
  reducers: {
    clearCurrent: state => {
      state.current = null
    },
  },
  extraReducers(builder) {
    builder
      .addCase(search.fulfilled, (state, action) => {
        state.list = action.payload.rows
        state.count = action.payload.count
      })
      .addCase(retrieve.fulfilled, (state, action) => {
        state.current = action.payload
      })
      .addCase(save.fulfilled, updateList)
      .addCase(destroy.fulfilled, (state, action) => {
        state.list = state.list?.filter(m => m.id !== action.payload.id)
      })
      .addCase(mentorList.fulfilled, (state, action) => {
        state.mentors = action.payload
      })
  },
})

export const { clearCurrent } = mentorshipSlice.actions
export default mentorshipSlice.reducer
